var initializeLanguageSwitcherLinks = function () {
    var de = document.querySelector('link[hreflang="de-DE"]');
    var linksDe = document.querySelectorAll('.c-country-selection__list-item a[href^="https://www.ltur.com/de/index"]');
    if (de) {
        linksDe.forEach(function (item) {
            if (item) {
                /// @ts-ignore
                item.href = de.href;
            }
        });
    }
    var ch = document.querySelector('link[hreflang="de-CH"]');
    var linksCh = document.querySelectorAll('.c-country-selection__list-item a[href^="https://www.ltur.com/ch/index"]');
    if (ch) {
        linksCh.forEach(function (item) {
            if (item) {
                /// @ts-ignore
                item.href = ch.href;
            }
        });
    }
    var at = document.querySelector('link[hreflang="de-AT"]');
    var linksAt = document.querySelectorAll('.c-country-selection__list-item a[href^="https://www.ltur.com/at/index"]');
    if (at) {
        linksAt.forEach(function (item) {
            if (item) {
                /// @ts-ignore
                item.href = at.href;
            }
        });
    }
    var fr = document.querySelector('link[hreflang="fr-FR"]');
    var linksFr = document.querySelectorAll('.c-country-selection__list-item a[href^="https://www.ltur.com/fr/index"]');
    if (fr) {
        linksFr.forEach(function (item) {
            if (item) {
                /// @ts-ignore
                item.href = fr.href;
            }
        });
    }
};
export default initializeLanguageSwitcherLinks;
